import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
 
  Box,
  Divider,
  
} from "@chakra-ui/react";
import { Col, Form, Row } from "react-bootstrap";

import SpinnerLoader from "components/Spinner/SpinnerLoader";
import {
  itemUnitOptions,
  taxOptions
} from "../PurchaseItem/selectedOptions";
import VendorCustomSelect from "../Vendors/VendorCustomSelect";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { clientProjectOptions } from "jsFunctions/clientProjectOptions";
import CustomPopover from "components/customPopover/customPopover";
import prJson from "components/jsonData/purchase.json";
import { fetchAsyncAddSalesItem,fetchAsyncUpdateSalesItem } from "redux/salesItemSlice";
import { allCurrency } from "./currencyJson";
import CurrencySelectField from "./currencySelected";
import { fetchAsyncGetClient } from "redux/clientProjectSlice";
import CrossIconButton from "components/CrossIconButtton/CrossIconButton";
import AmountInputField from "../component/amountField";
import TextAreaField from "../component/textAreaField";
import RadioField from "../component/radioField";
import CheckboxField from "../component/checkboxField";
import InputFormControl from "../component/inputFormControl";

const itemObj = {
    type: "goods",
    name: "",
    unit: {},
    hsnCode: "",
    currency:allCurrency[0],
    sacCode: "",
    sellingPrice: "",
    description: "",
    preClient:{},
    isDigitalService: false,
    interStateTaxRate:{}
}
const AddSalesItemForm = ({ 
  closeModal, 
  isOpen,
  isEdit = false,
  editData, 
  updateListItem,
  isDataLoading,
  listItemBtn

}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [itemData, setItemData] = useState(itemObj);
  const [clientOptions,setClientOptions] = useState([]);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const { addToast } = useToasts();
  const clientList = useSelector((state) => state.clientData);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;   
    setItemData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: null }));
    }
  };

  const handleSelectChange = (name, value) => {
    setItemData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: null }));
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!itemData.name) newErrors.name = prJson.required.name;
    if (!itemData.sellingPrice) newErrors.sellingPrice = prJson?.required?.sellPrice;
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAddItem = (data) => {
    setIsLoading(true)
    dispatch(fetchAsyncAddSalesItem(data))
      .then((res) => {
        if (res?.payload) {
          addToast(prJson.success.createdItem, { appearance: "success" });
          closeModal();
        } else {
          addToast(res?.error?.message, { appearance: "error" });
        }
      })
      .catch((error) => {
        addToast(prJson.error.generic, { appearance: "error" });
      }).finally(()=>{
        setIsLoading(false)
      });
  };

  const handleUpdateItem = (data) => {
    setIsLoading(true)
    dispatch(fetchAsyncUpdateSalesItem({ id: editData?._id, data: data }))
      .then((res) => {
        if (res?.payload) {
          addToast(prJson.success.updatedItem, { appearance: "success"});
          closeModal();
        }
      })
      .catch((err) => {
        addToast(prJson.error.generic, { appearance: "error" });
      }).finally(()=>{
        setIsLoading(false)

      })
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      if (!isEdit) {
        handleAddItem(itemData);
      } 
      else{
        handleUpdateItem(itemData)
      }
    }
  };
  const handleSaveAndUpdate = (e) => {
    e.preventDefault();
    if (validate()) {
        updateListItem(itemData)
        handleUpdateItem(itemData)
    }
  };

  useEffect(() => {
    if (editData) {
      const unit = itemUnitOptions.find((opt)=>opt.id === editData?.unt)
      const iStatetaxRate = taxOptions.find((opt)=>opt.id === editData.istr)
      const currency = allCurrency.find((opt)=>opt.code === editData.cur)

      const clientOpt = {
        label:editData?.cId?.clName,
        value:editData?.cId?._id
      }
      const existData = {
        _id: editData?._id,
        type: editData?.typ,
        name: editData?.name,
        unit: unit,
        hsnCode: editData?.hCd,
        sacCode: editData?.sCd,
        sellingPrice: editData?.prc,
        description: editData?.dc,
        isDigitalService: editData?.isDs,
        interStateTaxRate:iStatetaxRate || {},
        preClient:clientOpt,
        currency:currency
      }
        
      setItemData(existData);
    }
    
  }, [editData]);

  const getAllClientOptions = async()=>{
      const formOption = await clientProjectOptions('clName','_id',clientList) 
      setClientOptions(formOption);
  }
  useEffect(()=>{
    if(clientList){
      getAllClientOptions()
    }
  },[clientList])

  useEffect(()=>{
    dispatch(fetchAsyncGetClient());
  },[])

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={closeModal}
        className="modal-main"
        size="xl"
      >
        <ModalOverlay />
        <ModalContent
          top="0"
          margin="0 auto"
          bottom="0"
          className="add-form-modal-content"
        >
          <div className="fixed-header">
            <ModalHeader className="expense-modal-header mx-3">
              {isEdit ? "Edit" : "New"} Item
            </ModalHeader>
            <ModalCloseButton />
          </div>
          {isLoading || isDataLoading ? (
            <SpinnerLoader />
          ) : (
            <ModalBody>
              <Form className="addForm add-item-form mx-3">
                <div className="form-box">
                  <Row>
                    <Col className="col-3">
                      <Form.Label>Type</Form.Label>
                      <CustomPopover popoverText={prJson.pop.itemType} />
                    </Col>
                    <Col className="col-5">
                      <Box className="d-flex">
                        <RadioField
                          name="type"
                          value="goods"
                          isChecked={itemData.type === "goods"}
                          handleChange={handleChange}
                          label="Goods"
                        />
                        <RadioField
                          name="type"
                          customClass="mx-3"
                          value="service"
                          isChecked={itemData.type === "service"}
                          handleChange={handleChange}
                          label="Service"
                        />
                      </Box>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="col-3">
                      <Form.Label>
                        <span className="span-star">Name*</span>
                      </Form.Label>
                    </Col>
                    <Col className="col-5">
                      <InputFormControl
                        name="name"
                        customClass="form-control1"
                        value={itemData.name}
                        handleChange={(e) => handleChange(e)}
                      />
                      {errors.name && (
                        <p className="form_error">{errors.name}</p>
                      )}
                    </Col>
                  </Row>

                  <Row>
                    <Col className="col-3">
                      <Form.Label>Unit</Form.Label>
                      <CustomPopover popoverText={prJson.pop.unit} />
                    </Col>
                    <Col className="col-5">
                      <Box display="flex">
                        <VendorCustomSelect
                          options={itemUnitOptions}
                          placeHolder=""
                          defaultValue={itemData?.unit}
                          isSearchable
                          onChange={(newValue) =>
                            handleSelectChange("unit", newValue)
                          }
                        />
                        {itemData?.unit?.value && (
                          <CrossIconButton
                            onClick={() => handleSelectChange("unit", {})}
                          />
                        )}
                      </Box>
                    </Col>
                  </Row>
                  {itemData?.type === "goods" ? (
                    <Row>
                      <Col className="col-3">
                        <Form.Label className="red">HSN Code</Form.Label>
                      </Col>
                      <Col className="col-5">
                        <InputFormControl
                          name="hsnCode"
                          customClass="form-control1"
                          value={itemData.hsnCode}
                          handleChange={(e) => handleChange(e)}
                        />
                      </Col>
                    </Row>
                  ) : (
                    <>
                      <Row>
                        <Col className="col-3"></Col>
                        <Col className="col-5">
                          <CheckboxField
                            name="isDigitalService"
                            label={
                              <span className="digital-service">
                                It is a digital service
                                <CustomPopover
                                  popoverText={prJson.pop.digital}
                                />
                              </span>
                            }
                            customClass="vendor-add-checkbox"
                            isChecked={itemData.isDigitalService}
                            handleChange={handleChange}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col className="col-3">
                          <Form.Label className="red">SAC</Form.Label>
                        </Col>
                        <Col className="col-5">
                          <InputFormControl
                            name="sacCode"
                            customClass="form-control1"
                            value={itemData.sacCode}
                            handleChange={(e) => handleChange(e)}
                          />
                        </Col>
                      </Row>
                    </>
                  )}

                  <Divider
                    className="info-divider mt-3"
                    orientation="horizontal"
                  />
                  <Row>
                    <Col className="col-3">
                      <Form.Label>
                        <span className={`span-star borderBottomDash`}>
                          Currency*
                        </span>
                      </Form.Label>
                      <CustomPopover popoverText="Select the currency type for this item" />
                    </Col>
                    <Col className="col-5">
                      <CurrencySelectField
                        options={allCurrency}
                        placeHolder=""
                        defaultValue={itemData?.currency}
                        isSearchable
                        onChange={(newValue) =>
                          handleSelectChange("currency", newValue)
                        }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col className="col-3">
                      <Form.Label>
                        <span className={`span-star borderBottomDash`}>
                          Selling Price*
                        </span>
                        <CustomPopover popoverText="The rate at which you're going to sell this item." />
                      </Form.Label>
                    </Col>
                    <Col className="col-5">
                      <AmountInputField
                        symbol={itemData?.currency?.symbol}
                        value={itemData.sellingPrice}
                        placeholder="0.00"
                        name="sellingPrice"
                        handleChange={(value) => {
                          handleChange({
                            target: { name: "sellingPrice", value },
                          });
                        }}
                      />
                    </Col>
                    {errors.sellingPrice && (
                      <p className="form_error">{errors.sellingPrice}</p>
                    )}
                  </Row>

                  <Row>
                    <Col className="col-3">
                      <Form.Label>Description</Form.Label>
                    </Col>
                    <Col className="col-5">
                      <TextAreaField
                        rows={3}
                        name="description"
                        value={itemData.description}
                        handleChange={(e) => handleChange(e)}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col className="col-3">
                      <Form.Label>
                        <span>Preferred Client</span>
                      </Form.Label>
                    </Col>
                    <Col className="col-5">
                      <Box display="flex">
                        <VendorCustomSelect
                          options={clientOptions}
                          defaultValue={itemData?.preClient}
                          placeHolder=""
                          isSearchable
                          onChange={(newValue) =>
                            handleSelectChange("preClient", newValue)
                          }
                        />
                        {itemData?.preClient?.value && (
                          <CrossIconButton
                            onClick={() => handleSelectChange("preClient", {})}
                          />
                        )}
                      </Box>
                    </Col>
                  </Row>
                  <Divider
                    className="info-divider mt-3"
                    orientation="horizontal"
                  />
                  <h4 className="item-tax-heading">Default Tax Rates</h4>

                  <Row>
                    <Col className="col-3">
                      <Form.Label>
                        <span className="borderBottomDash">
                          Inter State Tax Rate
                        </span>
                      </Form.Label>
                    </Col>
                    <Col className="col-5">
                      <VendorCustomSelect
                        options={taxOptions}
                        placeHolder="Select a Tax"
                        defaultValue={itemData?.interStateTaxRate}
                        isSearchable
                        onChange={(newValue) =>
                          handleSelectChange("interStateTaxRate", newValue)
                        }
                      />
                    </Col>
                  </Row>
                  <Divider
                    className="info-divider mt-4"
                    orientation="horizontal"
                  />
                  <Box className="btn-footer mt-3">
                    {editData?._id && listItemBtn && (
                      <Button
                        className="btn save-btn"
                        onClick={(e) => handleSaveAndUpdate(e)}
                      >
                        Save & Update Line Item
                      </Button>
                    )}
                    <Button
                      className="btn save-btn"
                      onClick={(e) => handleSubmit(e)}
                    >
                      Save
                    </Button>
                    <Button className="btn cancel-btn" onClick={closeModal}>
                      Cancel
                    </Button>
                  </Box>
                </div>
              </Form>
            </ModalBody>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};

export default AddSalesItemForm;